import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '@app/servicios/storage/storage.service';
import { UsuariosService } from '@app/servicios/usuarios/usuarios.service';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private expiracion!: number;
  private id!: number;

  constructor(
    private router: Router,
    private usuariosService: UsuariosService,
    private storageService: StorageService
  ) {}

  public setToken(token: string): void {
    localStorage.setItem('AuthTokenT', token);
  }

  public getToken(): string | null {
    return localStorage.getItem('AuthTokenT');
  }

  public logOut(): void {
    localStorage.removeItem('AuthTokenT');
    localStorage.removeItem('userT');
    localStorage.removeItem('userT_id');
    localStorage.removeItem('userT_auth');
    this.router.navigate(['/login']);
  }

  private getPayload(): any {
    const token = this.getToken();
    if (!token) return null;
    try {
      const parts = token.split('.');
      if (parts.length < 2) return null;
      const payloadDecoded = atob(parts[1]);
      return JSON.parse(payloadDecoded);
    } catch {
      return null;
    }
  }

  public isLoggedIn(): boolean {
    return this.getToken() != null && this.notExpired();
  }

  public isAdmin(): boolean {
    const values = this.getPayload();
    if (!values) {
      return false;
    }

    const roles = values.rol;
    this.expiracion = values.exp;
    this.id = values.id;

    if (this.id) {
      this.usuariosService.usuario(this.id).subscribe((resp) => {
        if (resp && resp.data) {
          const userT = resp.data;
          const nombre = `${userT.nombre ?? ''} ${userT.apellido ?? ''}`.trim();
          this.storageService.setItem('userT', nombre);
          this.storageService.setItem('userT_id', userT.id);
          this.storageService.setItem('userT_auth', userT.tipo);
        }
      });
    }

    return roles === 'MAYORISTA';
  }

  public getId(): number | null {
    if (this.id) return this.id;
    const payload = this.getPayload();
    return payload?.id ?? null;
  }

  public notExpired(): boolean {
    let expiracion = this.expiracion;
    if (!expiracion) {
      const payload = this.getPayload();
      if (!payload || !payload.exp) return false;
      expiracion = payload.exp;
      this.expiracion = expiracion;
    }
    const ahora = Date.now() / 1000;
    return expiracion > ahora;
  }
}
